import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import time2TimeAgo from "../../utils/Helpers";
import ThemeContext, { AppTheme } from "../../context/ThemeContext";
import { navigate } from "@reach/router";

const API_URL = "https://hacker-news.firebaseio.com/v0/";
const NewsItem = ({ storyId }) => {
  const theme = useContext(ThemeContext)[0];
  const currentTheme = AppTheme[theme];
  const [story, setStory] = useState({});
  const fetchStory = async storyId => {
    try {
      const response = await axios.get(`${API_URL}item/${storyId}.json`);
      setStory(response.data);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    fetchStory(storyId);
  }, [storyId]);

  const navigateToDetail = storyId => {
    if (story.text) {
      navigate(`${storyId}`);
    }
  };
  return story && story.by !== "whoishiring" ? (
    <div className="news-item" style={{ borderBottom: `0.5px solid ${currentTheme.border}` }}>
      <a
        href={story.url && story.url}
        style={{ color: currentTheme.foreground }}
        onClick={() => navigateToDetail(storyId)}
      >
        <div className="news-wrapper">
          <div className="data">
            <div className="story-title">{story.title}</div>
            <div className="label">
              {story.by} | {time2TimeAgo(story.time)}
            </div>
          </div>
          <div className="points">
            <div className="score">{story.score} </div>
            <div className="label">points</div>
          </div>
        </div>
      </a>
    </div>
  ) : null;
};
const NewsList = ({ stories }) => {
  return (
    <div className="list">
      {stories.map(storyId => (
        <NewsItem key={storyId} storyId={storyId} />
      ))}
    </div>
  );
};

export default NewsList;
